import { render, staticRenderFns } from "./itemIdentificador.vue?vue&type=template&id=4277dc1c&"
import script from "./itemIdentificador.vue?vue&type=script&lang=js&"
export * from "./itemIdentificador.vue?vue&type=script&lang=js&"
import style0 from "./itemIdentificador.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports